import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-category-forms',
  templateUrl: './add-category-forms.component.html',
  styleUrls: ['./add-category-forms.component.css']
})
export class AddCategoryFormsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
